import { useState } from "react";
import { toast } from "react-toastify";

const useHTTPGPTAXIOS = () => {
  const endpoint = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001') + "/open-ai/chat/";

  const model16k = "gpt-3.5-turbo-16k";
  const model14k = "gpt-3.5-turbo";

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  };

  const [chunkMessage, setChunkMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const sendRequest = async (messages = null, module = null) => {
    setLoading(true);
    setError(null);

    const body = {
      messages,
      ...(module ? { module } : {}),
    };

    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers,
        body: JSON.stringify(body),
      });

      if (!response.ok && response.status === 401) {
        toast("Access Token is not valid!");
      }
      const responseData = await response.json();
      const message = responseData.choices
        .map((choice) => choice.message.content || "")
        .join("");
      setChunkMessage(message);
      return message
    } catch (err) {
      setError(err.message || "An error occurred.");
    } finally {
      setLoading(false);
    }
  };

  return {
    post: (body, module) => sendRequest(body, module),
    chunkMessage,
    loading,
    error,
  };
};

export default useHTTPGPTAXIOS;
